import "./AgileTrialExpiredComponent.scss";

import { Flex, Image, Text } from "@fluentui/react-northstar";
import React, { useEffect } from "react";

import { useHubspotChat } from "../../../_shared/actions/useHubspotChat";
import WarningImage from "../../../_shared/assets/agile-warning-image.svg";
import { SubscribeButton } from "../../../_shared/components/Checkout/SubscribeButton";
import { NavBarNew } from "../../../_shared/components/NavBar";
import { useTeamsContext } from "../../../_shared/state/TeamsContextProvider";

interface AgileTrialExpiredProps {
  showNavBar?: boolean;
}

export const AgileTrialExpired: React.FC<AgileTrialExpiredProps> = ({ showNavBar }) => {
  const { teamsContext } = useTeamsContext();
  const { loadHubspotChat } = useHubspotChat();

  useEffect(() => {
    loadHubspotChat(teamsContext);
  }, [teamsContext, loadHubspotChat]);

  return (
    <div>
      {showNavBar && <NavBarNew />}

      <Flex column hAlign="center">
        <Text as="h1"></Text>
        <Text
          content="Oh Bummer! Your AgilePolly trial has ended."
          size="large"
          weight="bold"
          color="brand"
          as="div"
        />

        <Text content="Choose a payment method to get going and create more standups." />

        <Image src={WarningImage} className="trial-expired__warning-image" />

        <div className="trial-expored__payment_button">
          <SubscribeButton trackingName="subscribe-trial-expired" />
        </div>
      </Flex>
    </div>
  );
};
